"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedJobStatusEnum = exports.JobOfferStatusEnum = exports.JobApplicationStatusEnum = exports.AppealCategoryEnum = void 0;
const zod_1 = require("zod");
exports.AppealCategoryEnum = zod_1.z.enum([
    'BENEFITS',
    'COMPANY_FEATURE',
    'FEATURE',
    'JOB_FEATURE',
]);
exports.JobApplicationStatusEnum = zod_1.z.enum([
    'ACCEPTED',
    'CANCELLED',
    'PENDING',
    'REJECTED',
]);
exports.JobOfferStatusEnum = zod_1.z.enum([
    'ACCEPTED',
    'CANCELLED',
    'EXPIRED',
    'REJECTED',
    'SCHEDULED',
    'SENT',
]);
exports.SavedJobStatusEnum = zod_1.z.enum([
    'RECRUITING',
    'CLOSING_SOON',
    'CLOSED',
]);
